<template>
	<div>
		<div class="header-block">
			<div class="bg-color page-header">
				<div class="swiper_text">
					<div v-for="(item,index) in swiperText" :key="index" :style="{right: right+'px'}" class="text-block">
						<img src="../../assets/image/components/swiperLogo.png" class="logo-style"/>
						<div class="text-style">{{ item.text.toLocaleUpperCase() }}</div>
					</div>
				</div>
			</div>
      <div class="navibar_block">
        <div class="navibar">
          <div class="tagBlock">
            <img src="../../assets/image/components/logo.png" @click="toPage(3)" class="tagImage-style"/>
            <div class="navi_tag_block">
              <div class="left_tag" :class="{'now_page':pageKey===0}" @click="toPage(0)">COMPANY PROFILE</div>
              <div class="left_tag" :class="{'now_page':pageKey===1}" @click="toPage(1)">SERVICE CONTENT</div>
              <div class="left_tag" :class="{'now_page':pageKey===2}" @click="toPage(2)">CONTACT US</div>
              <div class="get_in_touch" @click="toPage(2)">GET IN TOUCH</div>
            </div>
          </div>
        </div>
      </div>
		</div>
		<div style="height: 44px"></div>
	</div>
</template>

<script setup>
	import { reactive,onMounted,ref,onUnmounted,watch } from 'vue'
  import { useRouter } from 'vue-router'
  const route = useRouter()

  const swiperText = reactive([
		{id: 1,text: 'Congratulations on the new launch of AveryMedia website'},
		{id: 2,text: 'Congratulations on the new launch of AveryMedia website'},
		{id: 3,text: 'Congratulations on the new launch of AveryMedia website'},
		{id: 4,text: 'Congratulations on the new launch of AveryMedia website'},
	])
	const right = ref(0)
	const interval = ref("")
  const pageKey = ref(null)
  const path = reactive([
      '/about_us',
      '/trade_union',
      '/contact_us',
      '/avery_media'
  ])

	onMounted(()=>{
		let key = 0
		interval.value = setInterval(()=>{
			right.value += 1
			if(right.value%200 === 0){
				let obj = swiperText[key]
				swiperText.push(obj)
				key++
				if(key === 4){
					key = 0
				}
			}
		},10)
	})

	onUnmounted(()=>{
		clearInterval(interval.value)
	})


  watch(() => route.currentRoute.value,
      (newValue) => {
        console.log('newValue',window)
        pageKey.value = null
        path.forEach((item,index)=>{
          console.log(item,newValue.path)
          if (item === newValue.path) {
            pageKey.value = index
          }
        })
      }
  )

  const toPage = (index)=> {
    route.push(path[index])
  }
	
</script>

<style lang="scss" scoped>
  .now_page {
    color: #00DA71 !important;
  }
	.header-block{
		width: 100%;
		position: absolute;
		top: 0;
    z-index: 111;
	}
	.page-header {
		width: 100%;
		height: 44px;
		overflow: hidden;
		.swiper_text {
			width: 1920px;
			height: 100%;
			display: flex;
			align-items: center;
			overflow-x: hidden;
			margin: 0 auto;
		}
		.text-block {
			display: flex;
			align-items: center;
			padding-left: 10px;
			margin-right: 70px;
			position: relative;
			.logo-style {
				width: 22px;
				height: 22px;
				margin-right: 14px;
			}
			.text-style{
				font: {
					size: 0.875rem;
					family: 'Montserrat-Bold';
					weight: bold;
				}
				white-space: nowrap;
				color: #000000;
				line-height: 14px;
			}
		}
	}
  .navibar_block {
    width: 1920px;
    margin: 40px auto 0;
    height: 64px;
  }
	.navibar {
		width: 1727px;
    height: 100%;
    margin-left: 124px;
		background: linear-gradient(138deg, #00DA71 0%, #BAA6FF 33%, #0CB4FF 70%, #B3A6FF 100%);
		border-radius: 6px;
		padding: 4px;
		box-sizing: border-box;
		.tagBlock{
			width: 100%;
			height: 100%;
			background-color: #000000;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 248px 0 198px;
			box-sizing: border-box;
			border-radius: 4px;

			.tagImage-style{
				width: 200px;
				height: 48px;
        cursor: pointer;
			}
			.navi_tag_block{
				display: flex;
				align-items: center;
				color: #FFFFFF;
				white-space: nowrap;
				font:{
					size: 1rem;
					weight: 400;
					family: Montserrat-Regular;
				};
				div {
					cursor: pointer;
				}
				.left_tag{
					margin-left: 78px;
				}
				.get_in_touch{
					color: #AAA7FF;
					height: 30px;
					line-height: 30px;
					border-left: 2px solid #707070;
					padding-left: 26px;
					margin-left: 28px;
				}
			}
		}
	}
</style>